import './Footer.css';

import {OpenWebURL} from '../../utils/util';

import React from 'react';
import {useTranslation} from 'react-i18next';

const FooterLegal = () => {
  const {t} = useTranslation();

  return (
    <div className="footer-legal">
      <div className="footer-legal-links">
        <div className="legal-link">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              OpenWebURL(
                'weburl',
                'https://www.deere.com/en/privacy-and-data/'
              );
            }}
          >
            {t('PRIVACY_DATA')}
          </a>
        </div>
        <div className="legal-link">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              OpenWebURL(
                'weburl',
                'https://www.deere.com/en/privacy-and-data/terms/'
              );
            }}
          >
            {t('TERMS')}
          </a>
        </div>
      </div>
      <div className="copyright">{t('COPYRIGHT')}</div>
    </div>
  );
};

export default FooterLegal;
